import { render, staticRenderFns } from "./incidentals.vue?vue&type=template&id=53cff6cc&scoped=true&"
import script from "./incidentals.vue?vue&type=script&lang=js&"
export * from "./incidentals.vue?vue&type=script&lang=js&"
import style0 from "./incidentals.vue?vue&type=style&index=0&id=53cff6cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cff6cc",
  null
  
)

export default component.exports